import { DataVersion, IncidentProduct } from '@hakimo-ui/hakimo/types';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useSendIncidentReportEmail(
  product: IncidentProduct,
  onSuccess?: () => void,
  onError?: (err: Error) => void,
  dataVersion?: DataVersion
) {
  const searchParams = new URLSearchParams({ product });
  const request = new Request(
    `/v2/orm/location_incidents/incident-report/send-email` +
      `?${searchParams.toString()}`,
    { method: 'POST' }
  );
  withDataVersion(request, dataVersion);

  return useAuthenticatedMutation<null, FormData>(request, {
    getBody: (fd) => fd,
    onSuccess,
    onError,
    onSuccessInvalidationKeys: [['incidentDetail']],
  });
}

export default useSendIncidentReportEmail;
